import paginatedSearchAndSelectTemplate from './paginated-search-and-select.html';
import './paginated-search-and-select.scss';

let PaginatedSearchAndSelectDirective = ['$rootScope', '$translate', ($rootScope, $translate) => {
    const
        DEFAULT_ALL_ITEMS = 'All Items',
        DEFAULT_SELECTED_ITEMS = 'Selected: ',
        DEFAULT_NO_SELECTION = 'None',
        DEFAULT_ITEM_DELIMITER = ', ';

    return {
        require: 'ngModel',
        restrict: 'E',
        replace: true,
        scope: {
            modelValue: '=ngModel',
            options: '=',
            onscroll: "&",
            pageLimit: '=',
            key: '@',
            search: '=',
            modelChanged: '&ngChange',
            totalCount: '=',
            commonSearchGlag: '=',
            onClick: '&',
            allValue: '=',
            displayLabel: '=',
            noneSelected: '=',
            selectedPrefix: '=',
            allLabel: '=',
            isLoading: '=',
            labelName: '@',
            hideLabel: '=',
            toggleCount: '=',
            allowSingleSelect: '=',
            showOldSelected: '=',
            showSelectedFirst: '=',
            showFilterAction: '=',
            applyAction: '&',
            resetAction: '&',
            mode: '=',
            locationDistanceId:'=',
            billingType:'=',
            onShowAll: '&'
        },
        templateUrl: 'paginated-search-and-select.html',
        link: function (scope, elem, attrs, ngModel) {
            let allValues = [];
            let modelLoaded = false;
            let selectedItemLabel = [];
            let selectedItemValues = [];
            scope.currentPage = 1;
            // const pageLimit = 20;
            scope.isExpanded = false;
            scope.searchKey = '';
            scope.enabledItems = null;
            scope.totalSelected = 0;
            scope.selectAllFlag = false;
            scope.selectAllLoading = false;
            let selectAllSafetyTimeoutId = null;

            function stopSelectAllLoading() {
                scope.selectAllLoading = false;
                if (selectAllSafetyTimeoutId) {
                    clearTimeout(selectAllSafetyTimeoutId);
                    selectAllSafetyTimeoutId = null;
                }
            }
            scope.toggleSelector = function () {
                scope.isExpanded = !scope.isExpanded;
                if (scope.isExpanded) {
                    setTimeout(() => {
                        const searchInput = elem.find('input[type="text"]:not([disabled])');
                        if (searchInput && searchInput.length) {
                            searchInput.focus();
                        }
                    }, 100);
                }
            };

            scope.isDisabled = false;

            setTimeout(() => {
                allValues = scope.options;
                if (!scope.totalCount) {
                    scope.totalCount = 0;
                }
            }, 3000);

            attrs.$observe('required', function (value) {
                scope.required = !!value;
            });

            attrs.$observe('disabled', function (value) {
                scope.isDisabled = !!value;
            });

            scope.isTouched = function () {
                return ngModel ? ngModel.$touched : false;
            };

            scope.onBlurHandler = function () {
                if (ngModel) ngModel.$setTouched();
                setTimeout(() => {
                    if(scope.isExpanded === false) return;
                    if (elem[0].contains(document.activeElement)) {
                        if (!scope.search) elem[0].focus();
                    }
                    else {
                        scope.isExpanded = false;
                        scope.searchKey = '';
                        if(scope.billingType == false){
                            scope.locationDistanceId = null
                        }
                        if(scope.mode === 'edit'){
                            scope.searchBy('');
                            // scope.options = [];
                        }
                    }
                }, 50)
            };

            scope._onBlurHandler = function () {
                if(scope.isExpanded === false) return;
                setTimeout(() => {
                    elem[0].focus();
                });
            };

            var notifyChange = function () {
                setTimeout(() => {
                    scope.modelChanged();
                });
            };

            scope.searchBy = function (searchText) {
                setTimeout(() => {

                    if (searchText.length === 0 || searchText.length >= 1) {
                        if (allValues && allValues.length === 0) {
                            allValues = scope.options;
                        }
                        scope.selectAllFlag = false;
                        stopSelectAllLoading();
                        scope.onscroll({
                            searchKey: searchText,
                            offset: 1,
                            selectAllFlag: scope.selectAllFlag
                        });
                    }
                }, 50);
            }

            function pushModel() {
                if (!modelLoaded || !scope.enabledItems) return;
                if (!!scope.allValue && scope.enabledItems[scope.allValue]) { // if all value is enabled:
                    scope.modelValue = scope.allValue;
                    notifyChange();
                    return;
                }
                scope.modelValue = Object.keys(scope.enabledItems)
                    .reduce(function (p, c) {
                        if (scope.enabledItems[c]) {
                            p.push(c);
                            if (selectedItemValues.indexOf(c) == -1) {
                                selectedItemValues.push(c)
                                let lbl = _.filter(scope.options, (a) => a.value == c);
                                if (lbl && lbl.length) {
                                    selectedItemLabel.push(lbl[0].label);
                                    selectedItemLabel = (_.uniq(selectedItemLabel)).sort()
                                }
                            }
                        } else {
                            let vIndex = selectedItemValues.indexOf(c);
                            let keyIndex = _.findIndex(selectedItemLabel, (str) => {
                                if (!str) return;

                                str = str.toString()
                                return str.includes(c);
                            });

                            if (keyIndex >= 0) {
                                selectedItemLabel.splice(keyIndex, 1);
                            }
                            if (vIndex >= 0) {
                                selectedItemValues.splice(vIndex, 1);
                            }
                            scope.selectAllFlag = false
                        }
                        return p;
                    }, []);
                notifyChange();
            }

            function pullModel() {
                scope.enabledItems = {}; // reset enabled items
                let isModelArray = angular.isArray(scope.modelValue);
                if (!!scope.allValue && (scope.modelValue === scope.allValue
                    || (isModelArray && scope.modelValue.indexOf(scope.allValue) > -1))) { // all is enabled:
                    scope.enabledItems[scope.allValue] = true;
                    modelLoaded = true;
                    return;
                }
                if (angular.isArray(scope.modelValue)) {
                    scope.modelValue
                        .forEach(function (item) {
                            scope.enabledItems[item] = true;
                        });
                }
                else if (angular.isString(scope.modelValue) || angular.isNumber(scope.modelValue)) {
                    scope.enabledItems[scope.modelValue] = true;
                }
                modelLoaded = (scope.modelValue !== undefined);
            }

            scope.itemIsActive = function (item) {
                return !!scope.enabledItems[item.value];
            };

            scope.itemDisabled = function (item) {
                // if (scope.isSelectedAll()) return true;
                return false;
            };

            function wrapTag(content, tag) {
                return '<' + tag + '>' + content + '</' + tag + '>';
            }

            function itemExists(value) {
                let valueId = (value || {}).value || value;
                return !(scope.options || []).every(function (itm) {
                    return itm.value !== valueId;
                });
            }

            scope.itemVisible = function (item) {
                if (!itemExists(item)) return false;
                if (angular.isFunction(item.showIf)) {
                    return !!item.showIf.call(this, item);
                }
                return !item.hidden;
            };

            scope.currentLabel = function () {
                let
                    tag = 'span',
                    allItems = scope.options || [],
                    allLabel = scope.allLabel || DEFAULT_ALL_ITEMS,
                    itemDelim = scope.itemDelimiter || DEFAULT_ITEM_DELIMITER,
                    selPrefix = scope.selectedPrefix || DEFAULT_SELECTED_ITEMS,
                    noSelection = scope.noneSelected || DEFAULT_NO_SELECTION,
                    items = scope.enabledItems || {},
                    label;

                scope.totalSelected = 0;

                if (!!scope.allValue && items[scope.allValue]) {
                    selectedItemLabel = [];
                    selectedItemValues = [];
                    label = wrapTag(allLabel, tag);
                    scope.totalSelected = scope.totalCount;
                }
                else {
                    if(scope.options && scope.options.length === 0){
                        scope.modalValue = [];
                        items = scope.modalValue;
                    }                  
                    let
                        // indexed = allItems.reduce(function (p, c) {
                        //     p[c.value] = c;
                        //     return p;
                        // }, {}),
                        itemStr = Object.keys(items).map(e => e).join(itemDelim);
                    scope.totalSelected = Object.keys(items).length || 0;
                    //     .reduce(function (p, c) {
                    //         if (!!indexed[c] && scope.itemVisible(indexed[c])) {
                    //             p.push(indexed[c][scope.displayLabel]);
                    //         }
                    //         scope.totalSelected = p.length || 0;
                    //         return p;
                    //     }, []).join(itemDelim);
                    if (itemStr) {
                        label = wrapTag(selPrefix, tag) + itemStr;
                    }
                    else {
                        label = wrapTag(noSelection, tag);
                    }
                }
                return label;
            }

            scope.$watch('options', function (newValue, oldValue) {
                    if (newValue !== oldValue && scope.selectAllFlag) {

                        scope.selectAll();
                    }
            }, true);

            scope.isAllSelected = function () {
                if (!scope.totalCount) return false;
                if (!!scope.allValue && scope.enabledItems && scope.enabledItems[scope.allValue]) return true;
                return !!scope.enabledItems && Object.keys(scope.enabledItems).length >= scope.totalCount;
            };

            scope.selectAll = function () {
                scope.modelValue = [];
                scope.enabledItems = {};
                scope.selectAllFlag = true;

                const shouldFetchMore = scope.totalCount && scope.options.length < scope.totalCount;
                if (shouldFetchMore) {
                    scope.selectAllLoading = true;
                } else {
                    stopSelectAllLoading();
                }

                let ddElement = elem.find('.bind-cst-scroll')
                ddElement[0].scrollTop = ddElement[0].scrollHeight;

                scope.options.forEach(el => {
                    scope.modelValue.push(el.value)
                    scope.enabledItems[el.value] = true
                })

                if (shouldFetchMore) {
                    if (selectAllSafetyTimeoutId) clearTimeout(selectAllSafetyTimeoutId);
                    selectAllSafetyTimeoutId = setTimeout(stopSelectAllLoading, 20000);
                    scope.onscroll({
                        searchKey: scope.searchKey || '',
                        offset: scope.pageLimit ? Math.ceil((scope.options.length / scope.pageLimit) + 1) : scope.currentPage + 1,
                        selectAllFlag: scope.selectAllFlag
                    });
                }

                setTimeout(() => {
                    scope.modelChanged();
                    elem[0].focus();
                });
            }

            scope.selectNone = function () {
                scope.selectAllFlag = false;
                stopSelectAllLoading();
                if (scope.searchKey) {
                    scope.options.forEach(el => {
                        delete scope.enabledItems[el.value]
                    })
                } else {
                    scope.enabledItems = {};
                }
                setTimeout(() => {
                    scope.modelChanged();
                    elem[0].focus();
                });
            }

            scope.showAllLocation = function () {
                scope.locationDistanceId = null;
                setTimeout(() => {
                    scope.options = [];
                    scope.onscroll({
                        searchKey: scope.searchKey || '',
                        locationDistanceId: scope.locationDistanceId,
                        offset: 1,
                        selectAllFlag: scope.selectAllFlag
                    });
                    scope.onShowAll();

                });
                scope.modelChanged();
            }
            
            scope.itemClicked = function (item) {
                if (angular.isArray(scope.modelValue) && scope.modelValue.length == 0) {
                    scope.modelValue = null;
                } else {
                    scope.modelValue = item.value === scope.modelValue ? null : item.value;
                }
                scope.isExpanded = false;
                setTimeout(() => {
                    scope.modelChanged();
                });
            };

            scope.isValid = function () {
                if (!scope.required) return true;
                if (angular.isArray(scope.modelValue)) {
                    return scope.modelValue.length > 0;
                }
                return !!scope.modelValue;
            };

            scope.$watch('enabledItems', pushModel, true);
            scope.$watch('modelValue', pullModel, true);

            scope.sortShowFirst = function (item) {
                let selectedVal = (scope.enabledItems && Object.keys(scope.enabledItems).length) ? Object.keys(scope.enabledItems) : [];
                if (scope.options && scope.options.length && selectedVal.length && scope.showSelectedFirst) {
                    let isSelected = selectedVal.findIndex(ci => String(ci) === String(item.value))
                    return (isSelected >= 0) ? -1 : 1;
                } else {
                    return -1;
                }
            }

            scope._resetAction = function () {
                if (scope.modelValue && scope.modelValue.length) {
                    scope.modelValue = scope.allowSingleSelect ? null : [];
                    setTimeout(() => {
                        scope.applyAction();
                        scope.toggleSelector();
                    }, 500)
                }
            }

            scope._applyAction = function () {
                scope.applyAction();
                scope.toggleSelector();
            }
            scope.flag = false;
            setTimeout(() => {
                elem.find('.bind-cst-scroll').bind('scroll', function (e) {
                    var currentItem = $(this);
                    if (currentItem.scrollTop() + currentItem.innerHeight() >= currentItem[0].scrollHeight - 1) {
                        if (scope.totalCount !== scope.options.length && !scope.isLoading && !scope.selectAllLoading) {
                            if(scope.flag === true){
                                scope.searchBy('');
                                scope.flag = false;
                            }
                            scope.onscroll({
                                searchKey: scope.searchKey || '',
                                offset: scope.pageLimit ? Math.ceil((scope.options.length / scope.pageLimit) + 1) : scope.currentPage + 1,
                                selectAllFlag: scope.selectAllFlag
                            });
                            scope.currentPage += 1;
                        }
                    }
                })
            }, 300)
        }
    };
}];

export default PaginatedSearchAndSelectDirective;


// WEBPACK FOOTER //
// ./client/app/common/paginated-search-and-select/paginated-search-and-select.directive.js